import React from "react";

const FreqAskedQuest = () => {
    return (
        <div className="section-six">
            <h3>Frequently Asked Questions</h3>
            <div className="faq-list">
                <div className="faq">
                    <h6>
                    Will my website be optimized for search engines (SEO)?
                    </h6>
                    <p>
                    Yes, we incorporate basic SEO best practices during the website development process. This includes optimizing site speed, using clean code, and ensuring mobile friendliness. 
                    </p>
                </div>

                <div className="faq">
                    <h6>
                    How can I ensure that my business objectives are aligned with the Product Discovery process?
                    </h6>
                    <p>
                    Our dedicated Product Owner will work closely with you to ensure a seamless alignment between your objectives and our deliverables. 
                    </p>
                </div>

                <div className="faq">
                    <h6>
                    What if I don’t have a clear vision for my product’s design?
                    </h6>
                    <p>
                    That's perfectly okay! We specialize in helping clients bring their ideas to life. Our team will work with you to explore design concepts and possibilities.
                    </p>
                </div>

                <div className="faq">
                    <h6>
                    Do you provide ongoing website/web apps maintenance and support?
                    </h6>
                    <p>
                    Yes, we offer ongoing web site/web app application maintenance and support services to ensure that your application remains secure, up to date, and free from issues. Our support plans are designed to fit your needs and budget. 
                    </p>
                </div>

                <div className="faq">
                    <h6>
                    How long does app development take?
                    </h6>
                    <p>
                    Timelines vary based on app complexity. However, we streamline requirements to deliver an MVP in 8-12 weeks.
                    </p>
                </div>

                <div className="faq">
                    <h6>
                    Can you update and enhance my existing app?
                    </h6>
                    <p>
                    Absolutely. We offer app enhancement and update services for existing apps. 
                    </p>
                </div>
            </div>
        </div>
    )
}

export default FreqAskedQuest